import React, { useState } from 'react'

import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { setSystemMessage } from '../../features/systemMessageSlice'
import { Backdrop, Button, CircularProgress, Typography } from '@mui/material'
import { alpha, useTheme } from '@mui/material/styles'

import scanApi from '../../api/scan'
import { ActionBox, ActionButtonItem, ActionDivButtonGroup } from '../../styles/components/TableActionsInputStyle'

const ScanActionsInput = ({ getNewData, clearFilters, isLoading, filters, selectedRows, maxRowsCount }) => {
  const [isExporting, setIsExporting] = useState(false)
  const dispatch = useDispatch()
  const theme = useTheme()

  const exportCount = () => {
    if (selectedRows.size !== 0) {
      return `selected (${selectedRows.size})`
    }
    if (Object.keys(filters).length !== 0) {
      return `Filtered (${maxRowsCount ?? 0})`
    }
    return '(All)'
  }

  const handleExport = async () => {
    await dispatch(setSystemMessage({ message: `CSV export has started`, severity: 'success' }))
    setIsExporting(true)
    const selectedIds = [...selectedRows].filter((value) => Number.isInteger(value))

    await scanApi
      .export(selectedIds, filters)
      .then((res) => {
        const blob = new Blob([res.data], { type: 'data:text/csvcharset=utf-8,' })
        const blobURL = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.download = `export_scan_${new Date().toJSON().slice(0, 10)}.csv`
        anchor.href = blobURL
        anchor.dataset.downloadurl = ['text/csv', anchor.download, anchor.href].join(':')
        anchor.click()
      })
      .finally(() => {
        setIsExporting(false)
      })
  }

  return (
    <>
      <ActionBox className="sticky-vertical">
        <ActionDivButtonGroup style={{ marginLeft: 'auto' }}>
          <ActionButtonItem variant="contained" color="primary" onClick={getNewData} disabled={isLoading}>
            Refresh data
          </ActionButtonItem>
          <ActionButtonItem variant="contained" color="primary" onClick={clearFilters}>
            Clear filters
          </ActionButtonItem>
          <ActionButtonItem
            variant="contained"
            color="primary"
            onClick={handleExport}
            disabled={isLoading || isExporting}
          >
            Export {exportCount()}
          </ActionButtonItem>
        </ActionDivButtonGroup>
      </ActionBox>
      <Backdrop
        open={isExporting}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: alpha(theme.palette.primary.dark, 0.9),
          flexDirection: 'column',
        }}
      >
        <CircularProgress size={80} />
        <Typography color="primary.light" sx={{ mt: 3, fontSize: '1.5rem' }}>
          Wait, please…
        </Typography>
        <Button variant="contained" color="secondary" sx={{ mt: 3, visibility: 'hidden' }}>
          Cancel
        </Button>
      </Backdrop>
    </>
  )
}

ScanActionsInput.propTypes = {
  getNewData: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  filters: PropTypes.object,
  selectedRows: PropTypes.instanceOf(Set),
  maxRowsCount: PropTypes.number,
}

export default ScanActionsInput
